package com.neurobs.ccabserver.transcriptreview.states

import com.neurobs.ccab.IdentityData
import com.neurobs.react.{StateAttribute, StateContextBase}
import com.neurobs.util.Guid

case class UserState
(
	userData: StateAttribute[IdentityData],
)
{
  def userIsSiteAdmin: Boolean = userData.value.isSiteAdmin
  def userId: Long = userData.value.legacyUserId
  def username: String = userData.value.email
  def accountId: Long = userData.value.legacyAccountId
}

object UserState extends StateContextBase[UserState, IdentityData] {
	override protected def defaultStateValue() = IdentityData(Guid.nullGuid, Guid.nullGuid, "", "", "", 0, 0, Seq())

	override protected def makeState(a: StateAttribute[IdentityData]) = UserState(a)
}
